import Alert from 'client/components/aria/Alert/Alert';
import { FormattedMessage, useIntl } from 'react-intl';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

const EnquiryAlertEmergency = (props) => {
    const intl = useIntl();
    return (
        <Alert
            title={intl.formatMessage({ id: 'enquiryAlerts.emergency.title' })}
            variant="secondary"
            {...props}
        >
            <FormattedMessage id="enquiryAlerts.emergency"/>
        </Alert>
    );
};

EnquiryAlertEmergency.propTypes = {
    ...defaultAriaProps
};

export default EnquiryAlertEmergency;
